import { DataBean } from "../DataBean";

export class ArticleClassType extends DataBean{

    
      
}